var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocked = function SvgLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.167,10a0.833,0.833 0 1,0 1.666,0a0.833,0.833 0 1,0 -1.666,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.33h1v3h-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16h12V6H2zm1-1h10V7H3z",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7V4.256c0-1.933 1.567-4 4-4s4 2 4 4V7h-1V4.256c0-1.933-1.567-3-3-3s-3 1.134-3 3V7z"
  })));
};
export default SvgLocked;